export default __webpack_public_path__ + "static/media/barkhausen.6485081e.png";